import { useMemo, useContext } from 'react'
import { observer } from 'mobx-react'
import { Button } from 'antd'
import { EasyIcon, ListTableContext, EditPropsContext, EditContext, ModalContext, LoadableButton } from 'src/components'
import { getValidBtns } from '../helper'
import { getTableOperateColumns } from '../tabler'
import { $consts } from 'src/plugins'

const EditPageHeader = () => {
  const table = useContext(ListTableContext)
  const editProps = useContext(EditPropsContext)
  const edit = useContext(EditContext)
  const modal = useContext(ModalContext)

  const formParams = useMemo(() => {
    return editProps?.formData?.formDisabled !== undefined ? { __READONLY__: editProps.formData.formDisabled } : {}
  }, [editProps?.formData?.formDisabled])

  const operateDisabled = useMemo(() => {
    return formParams.__READONLY__ || editProps?.formData?.operateDisabled
  }, [formParams.__READONLY__, editProps?.formData?.operateDisabled])

  // 列表表单的行操作按钮，放在编辑表单头部【暂时取消，230320】
  const operateBtns = useMemo(() => {
    if (operateDisabled) return

    // 不要将列表表单配置的按钮放在编辑表单中，计划改成单独在编辑表单中配置 230320
    // const validBtns = table?.tableConfig.RowBtns.filter((btn: any) => btn.BTN_TYPE !== $consts['TABLE/BTN_TYPE_EDIT_PAGE'])
    const validBtns: any[] = []
    const column = getTableOperateColumns(validBtns)[0]
    return table?.selectedRow ? column?.render(null, table.selectedRow) : undefined
  }, [operateDisabled, table?.tableConfig.RowBtns, table?.selectedRow])

  const enableBtns = useMemo(() => {
    return getValidBtns(edit.editConfig.Nav_PageEdit?.Nav_Btns)
  }, [edit.editConfig.Nav_PageEdit?.Nav_Btns])

  const visible = useMemo(() => {
    return edit.editConfig.Nav_PageEdit?.Nav_PageEdit?.BTN_POSITION !== $consts['EDIT/PAGE_BTN_LOCATE_BOTTOM']
  }, [edit.editConfig.Nav_PageEdit?.Nav_PageEdit?.BTN_POSITION])

  if (!visible) return null

  if (!enableBtns.length && !operateBtns?.length) return null

  return (
    <div className='edit-page__header'>
      {
        enableBtns.map((btn: any, index: number) => (
          <LoadableButton
            key={`${btn.ID}_${index}`}
            pageType={$consts['TABLE/FORM_TYPE_EDIT_PAGE']}
            locateBtn={$consts['TABLE/BTN_LOCATE_PAGER']}
            config={Object.assign({}, btn, formParams)}
          />
        ))
      }
      {operateBtns}
      {modal.initDone ? <Button icon={<EasyIcon type='CloseOutlined' />} onClick={() => modal.close()}>关闭</Button> : null}
    </div>
  )
}

export default observer(EditPageHeader)